/* global videojs */

var POLL_INTERVAL_MS = 250;
var MAX_ATTEMPTS = 20;

/**
 * Apply caption visibility behavior based on component configuration.
 * @param {Object} player - Brightcove player instance.
 * @param {string} captionsPreference - Captions preference ('show'|'hide').
 */
function applyCaptionsPreference(player, captionsPreference) {
    var tracks = player.textTracks && player.textTracks();
    if (!tracks || !tracks.length) {
        return;
    }

    var shouldShowCaptions = captionsPreference === 'show';
    var hasShownTrack = false;

    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        if (track) {
            var isCaptionTrack = track.kind === 'captions' || track.kind === 'subtitles';
            if (isCaptionTrack) {
                if (shouldShowCaptions && !hasShownTrack) {
                    track.mode = 'showing';
                    hasShownTrack = true;
                } else {
                    track.mode = 'disabled';
                }
            }
        }
    }
}

/**
 * Attach Brightcove handlers that swap the component to poster state on errors
 * and apply configured captions visibility.
 * @param {string} playerId - The video-js element id.
 * @param {HTMLElement} root - The component root element.
 * @param {string} captionsPreference - Captions preference ('show'|'hide').
 */
function attachPlayerHandlers(playerId, root, captionsPreference) {
    videojs.getPlayer(playerId).ready(function () {
        var player = this;

        // Text tracks are not available at ready() — they load with video metadata.
        // Apply on loadedmetadata so tracks are present when the preference is applied.
        player.one('loadedmetadata', function () {
            applyCaptionsPreference(player, captionsPreference);
        });

        if (player.error()) {
            root.classList.add('has-video-error');
            return;
        }
        player.on('error', function () {
            root.classList.add('has-video-error');
        });
    });
}

/**
 * Initialize Brightcove error handlers after Brightcove has bootstrapped.
 *
 * Pre-collects all (id, root) player pairs and polls until window.videojs is available
 * AND all players are registered in the video.js registry. videojs.getPlayer() returns
 * undefined if called before Brightcove's async initialization completes, which would
 * throw a TypeError — so registration is verified per player before attaching handlers.
 */
function initVideoPlayers() {
    var roots = document.querySelectorAll('.media-component[data-media-type="video"]');

    if (!roots.length) {
        return;
    }

    // Pre-collect all (id, root) pairs so the poll can verify registration per player
    var players = [];
    roots.forEach(function (root) {
        var playerEl = root.querySelector('video-js[id]');
        if (playerEl) {
            players.push({
                id: playerEl.id,
                root: root,
                captionsPreference: playerEl.getAttribute('data-captions-preference') || 'hide'
            });
        }
    });

    if (!players.length) {
        return;
    }

    var attempts = 0;
    var poll = setInterval(function () {
        attempts++;
        var allRegistered = window.videojs && players.every(function (p) {
            return videojs.getPlayer(p.id);
        });

        if (allRegistered || attempts >= MAX_ATTEMPTS) {
            clearInterval(poll);

            if (!allRegistered) {
                players.filter(function (p) {
                    return !(window.videojs && videojs.getPlayer(p.id));
                }).forEach(function (p) {
                    p.root.classList.add('has-video-error');
                });

                // eslint-disable-next-line no-console
                console.warn('mediaComponent: videojs unavailable or players not registered after timeout — enabling poster fallback');
            }

            players.filter(function (p) {
                return window.videojs && videojs.getPlayer(p.id);
            }).forEach(function (p) {
                attachPlayerHandlers(p.id, p.root, p.captionsPreference);
            });
        }
    }, POLL_INTERVAL_MS);
}

/**
 * Initialize media components.
 */
function init() {
    var roots = document.querySelectorAll('.media-component[data-media-type="video"]');

    if (!roots.length) {
        return;
    }

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        roots.forEach(function (root) {
            root.classList.add('media-component--reduced-motion');
        });
        return;
    }

    initVideoPlayers();
}

module.exports = {
    init: init
};
